<template>
  <div v-loading="loading" element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <div style="padding: 0;width:100%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
      <div ref="total_height" id="download" style="height: 95%;width: 100%;overflow-x: auto;overflow-y: hidden">

        <div style="display: flex;margin-top: 2px;text-align: center;">
          <div v-for="calendar in state.dataList" style="width: 100%" :key="calendar">
            <div style="margin-left: 5px;height: 46px" class="border color">
              <div>{{ calendar.time }}</div>
              <div>{{ calendar.week }}</div>
            </div>
          </div>
        </div>

        <div style="height: 91%;overflow-y: auto;overflow-x: hidden;width: 100%;display: flex;" id="dynamicDiv1" >
          <div class="total_style" v-for="item in state.dataList" style="width: 100%" :key="item">
            <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">产线未开</div>
            <div v-if="item.line_bool" class="data_style">
              <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2">
                <div class="data_style3">
                  <span v-if="lineCnt.dayShiftCnt" class="data_style4">&nbsp;白{{ lineCnt.dayShiftCnt }}&nbsp;</span>
                  <span v-if="lineCnt.nightShiftCnt"
                        class="data_style5">&nbsp;夜{{ lineCnt.nightShiftCnt }}&nbsp;</span>
                </div>
                <div :class="lineCnt.class_name"
                     :style="lineCnt.dayShiftCnt?dayMaxLineHeight[lineCnt.class_name]:nightMaxLineHeight[lineCnt.class_name]">
                  <draggable :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                             ghost-class="ghost" chosen-class="chosenClass" animation="300" :sort="true">
                    <template #item="{ element }">
                      <div v-if="JSON.stringify(element) !== '{}'"
                           style="background-color: #e7e7e7"
                           :style="element.is_material_shortage == false?'border-left: solid 3px rgb(103, 194, 58) !important':'border-left: solid 3px red !important;'"
                           class="item"
                           :class="element.class_name">
                        <el-row style="line-height: initial;">
                          <el-col :class="element.class_name" style="border: solid 0 #0478e4 !important" :span="24">
                            <span style="color: whitesmoke">{{ element.wujian_name }}-</span>
                            <span style="color: whitesmoke">{{ element.scheduling_floor }}</span>
                          </el-col>
                        </el-row>
                        <div :class="element.is_material_shortage == false?'batchNoStyle1':'batchNoStyle2'"
                             style="border-top: #909399 1px solid;border-bottom: #909399 1px solid;">
                          <span>{{ element.batch_no }}</span>
                          <span style="color: #67c23a;margin-left: 35px;">{{ element.reality_num }}</span>
                          <span style="color: black">&nbsp;/&nbsp;</span>
                          <span style="color: #f56c6c">{{ element.plan_production_quantity }}&nbsp;</span>
                          <span style="color: black;">/&nbsp;{{ element.total_reality_num }}&nbsp;/&nbsp;</span>
                          <span style="color: #909399">{{ element.unit_num }}</span>
                        </div>
                        <div v-if="element.remark" style="height: auto;">备注：{{ element.remark }}</div>
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";
import html2canvas from "html2canvas"
export default {
  name: "ZhiZaoKanBan5",
  components: {draggable},
  data() {
    return {
      startDate: '', //用来处理前段显示时间的
      endDate: '', //用来处理前段显示时间的
      startTime: '', //传后端的时间
      endTime: '', //传后端的时间
      assemblyEndTime:'',
      state:{
        dataList:[],
      },
      wujian_border_color:'',
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      materialDetailsBool: false, //控制物料详情页面
      formWujianData: {},
      plan_production_quantity:'',
      remark: '',
      lineBool:false,//false表示白班 true表示夜班
      loading:false,
      maxHeight: "",//获取页面的最大高度
      dayMaxLineHeight:{},
      nightMaxLineHeight:{},
      takeScreenshotBool:false,
      importBool: false,
      cnt:0
    }
  }, methods: {
    async takeScreenshot() {
      this.takeScreenshotBool = true
      await html2canvas(document.getElementById("download"),{
        scale: 2, // 设置放大的倍数
        useCORS: true, // 如果截图内容包含跨域图片，确保已设置CORS
      }).then(function(canvas) {
        //let tempImg = new Image();
        //tempImg.src = canvas.toDataURL()
        var dataUrl = canvas.toDataURL("image/jpeg");
        var a = document.createElement('a'); // 创建一个a节点插入的document
        var event = new MouseEvent('click') // 模拟鼠标click点击事件
        a.download = new Date().getTime(); // 设置a节点的download属性值(图片名称)
        a.href = dataUrl ; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event); // 触发鼠标点击事件
      });
      this.takeScreenshotBool = false
    },
    beforeClose() {
      this.materialDetailsBool = false;
    },
    getTotalPlanCalendarLineData(startTime,endTime) {
      this.loading = true;
      let params = {startTime:startTime, endTime:endTime, weekList:this.weekList}
      this.$axios.post('mfg/assemblyPlan/getTotalPlanCalendarLineData', params).then(response => {
        let res = response.data
        if (res.code !== 0){
          this.loading = false;
          return this.$message.error(res.message);
        }
        this.state.dataList = res.data;
        console.log("dataList==",this.state.dataList)
        this.maxHeight = "";
        this.dayMaxLineHeight = {};
        this.nightMaxLineHeight = {};
        setTimeout(() => {
          this.getMaxHeight();
          this.getAddEventListener();
        }, 300)
        this.loading = false;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    getMaxHeight() {
      var h_max2 = 4;
      for (let index = 0; index < 6; index++) {
        let name = "day_class" + (index+1);
        //白
        var widthBox = document.getElementsByClassName("day_class"+(index+1)+"");
        if (widthBox != undefined && widthBox.length > 0) {
          let h_max = 0;
          for (let i = 0; i < widthBox.length; i++) {
            if (h_max < widthBox[i].clientHeight) {
              h_max = widthBox[i].clientHeight;
            }
          }
          this.dayMaxLineHeight[name] = "height: "+h_max+"px;";
          h_max2 += h_max;
        }

        //夜
        let name1 = "night_class" + (index+1);
        var widthBox1 = document.getElementsByClassName("night_class"+(index+1)+"");
        if (widthBox1 != undefined && widthBox1.length > 0) {
          let h_max1 = 0;
          for (let i = 0; i < widthBox1.length; i++) {
            if (h_max1 < widthBox1[i].clientHeight) {
              h_max1 = widthBox1[i].clientHeight;
            }
          }
          this.nightMaxLineHeight[name1] = "height: "+h_max1+"px;";
          h_max2 += h_max1;
        }
      }
      this.maxHeight = "height: "+(h_max2 + 46 + 150)+"px;";
      console.log("widthBox1_1==",this.maxHeight)
      console.log("widthBox1_1==",this.dayMaxLineHeight)
      console.log("widthBox1_1==111",this.nightMaxLineHeight)
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      obj.startTime = moment().format('YYYY-MM-DD');
      obj.endTime = moment(obj.startTime).add(6,'days').format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    formatTime(startTime, endTime) {
      console.log("startTime=",startTime)
      console.log("endTime=",endTime)
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1,'days');
      let endDate = moment(endTime);
      while (startDate.isBefore(endDate)) {
        startDate.add(1,'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        this.weekList.push({time});
      }

      let weeks = ["一","二","三","四","五","六","日"]
      let cnt = 0;
      for (let i = 0; i < this.weekList.length; i++) {
        if (i === 7) {
          cnt = 0;
        }
        this.weekList[i]['week'] = "(" + weeks[cnt] + ")";
        cnt += 1;
      }

      this.startDate = moment(startTime).format('MM') + "-" + moment(startTime).format('DD');
      this.endDate = moment(endTime).format('MM') + "-" + moment(endTime).format('DD');
      this.week.push(this.startDate);
      this.week.push(this.endDate);
      this.getTotalPlanCalendarLineData(startTime, endTime);
    },
    getAssemblyEndTime(){
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/assemblyProduction/getAssemblyEndTime',params).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime,obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getAddEventListener() {
      // 获取需要动态改变宽度的 div
      const dynamicDiv = document.getElementById('download');
      const dynamicDiv1 = document.getElementById('dynamicDiv1');
      let width = dynamicDiv1.offsetWidth;
      // 初始化上一次的 scrollLeft 值
      let lastScrollLeft = 0;
      // 监听窗口的滚动事件
      dynamicDiv.addEventListener('scroll', function() {
        // 获取当前的 scrollLeft 值
        const currentScrollLeft = dynamicDiv.scrollLeft;
        // 判断滚动方向
        if (currentScrollLeft > lastScrollLeft) {
          console.log('Scrolling right');
        } else if (currentScrollLeft < lastScrollLeft) {
          console.log('Scrolling left');
        }

        // 更新 lastScrollLeft 值
        lastScrollLeft = currentScrollLeft;
        // 设置新的宽度
        dynamicDiv1.style.width = (width + lastScrollLeft) + 'px';
      });
    }
  },created() {
    this.getAssemblyEndTime();
  },mounted() {
  }
}
</script>

<style scoped>
.border {
  border:rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: #e7e7e7;
}

.center {
  text-align: center;
  line-height: 32px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item {
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color:  #e7e7e7;
}


.chosenClass {
  font-size: 14px;
  font-weight: bold;
}

/*div样式*/
.week {
  border: #909399 0 solid;background-color: white; color: rgb(4, 134, 254);
}

.total_style {
  width:auto;
  align-items:center;
  margin-left: 5px;
}

.time {
  width:100%;
  text-align: center;
  margin-top: 5px;
}

.data_style {
  width:100%;
  height: auto;
}

.data_style1 {
  width:100%;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width:100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: #0478e4;
  font-size: 14px;
}

.data_style5 {
  background-color: black;
  margin-left: 2px;
  font-size: 14px;
}

/*动态样式*/

.batchNoStyle1 {
  color: #0478e4
}

.batchNoStyle2 {
  color: red
}

.scrollbar::-webkit-scrollbar{
  display: none;
}

.prompt {
  color:rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


.el-select .el-input {
  display: flex;
  height: 40px;
}

.wujian_border_color1 {
  background-color: #0788ff;
  border: solid 2px #0788ff !important
}

.wujian_border_color2 {
  background-color: #45c388;
  border: solid 2px #45c388 !important
}

.wujian_border_color3 {
  background-color: #b96bdd;
  border: solid 2px #b96bdd !important
}

.wujian_border_color4 {
  background-color: #FAC858;
  border: solid 2px #FAC858 !important
}

.wujian_border_color5 {
  background-color: #91CC75;
  border: solid 2px #91CC75 !important
}

.wujian_border_color6 {
  background-color: #73C0DE;
  border: solid 2px #73C0DE !important
}

.wujian_border_color7 {
  background-color: #EE6666;
  border: solid 2px #EE6666 !important
}

.wujian_border_color8 {
  background-color: #ef71c8;
  border: solid 2px #ef71c8 !important
}

.wujian_border_color9 {
  background-color: #73e936;
  border: solid 2px #73e936 !important
}

.wujian_border_color10 {
  background-color: #bebc73;
  border: solid 2px #bebc73 !important
}

/* 隐藏滚动条 */
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* 使滚动条透明 */
}
</style>